import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=bbefd838&scoped=true&"
import script from "./StepFour.vue?vue&type=script&lang=js&"
export * from "./StepFour.vue?vue&type=script&lang=js&"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=bbefd838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbefd838",
  null
  
)

export default component.exports